export const modal = {
	init: function(modalContainer) {
		if (!modalContainer) return;
		this.modalContainer = modalContainer;
		this.modalOpenBtns = document.querySelectorAll('[data-modal="open"]');
		this.body = document.querySelector('body');
		this.modalSubmit = modalContainer.querySelector('.modal__submit-btn');
		this.modalBox = modalContainer.querySelector('.modal__box');
		this.modalCloseBtn = modalContainer.querySelector('.modal__close-btn');
		this.allCheckboxes = modalContainer.querySelectorAll('input[type=checkbox]');
		this.arr = [];
		this.checkedCheckboxes;

		this.addListeners();
	},

	addListeners: function() {
		window.addEventListener('pageshow', _=> {
			this.clearCheckboxCache()
		});

		this.modalBox.addEventListener('click', (e)=> {
			e.stopPropagation();
		});

		[].slice.call(this.modalOpenBtns).forEach(oneBtn => {
			oneBtn.addEventListener('click', (e)=> {
				this.modalContainer.classList.add('modal--open');
				this.body.classList.add('modalOpen');
			});
		});

		this.modalCloseBtn.addEventListener('click', (e)=> {
			this.modalContainer.classList.remove('modal--open');
			this.body.classList.remove('modalOpen');
			this.removeCheckboxesCheck(this.modalContainer);
		});

		this.modalContainer.addEventListener('click', (e)=> {
			this.modalContainer.classList.remove('modal--open');
			this.body.classList.remove('modalOpen');
			this.removeCheckboxesCheck(this.modalContainer);
		});


		[].slice.call(this.allCheckboxes).forEach(checkbox => {
			checkbox.addEventListener('change', _=> {
				this.getCheckboxesValue(checkbox);
				this.checkIfChecked();
			});
		});

		this.modalSubmit.addEventListener('click', (e)=> {
			if (e.target.classList.contains('jsDisabled')) {
				e.preventDefault();
			} else {
				const link = '/doctor-bardahl?symptomes=';
				e.target.href = link + this.checkedCheckboxes;
			}
		});
	},

	removeCheckboxesCheck: function(modalContainer) {
		if (modalContainer.dataset.modal) return;
		[].slice.call(this.allCheckboxes).forEach(checkbox => {
			checkbox.checked = false;
		});
		this.arr = [];
		this.checkIfChecked();
	},

	getCheckboxesValue: function(checkbox) {
		if (checkbox.checked) {
			this.arr.push(checkbox.id);
		} else {
			const index = this.arr.indexOf(checkbox.id);
			if (index > -1) {
				this.arr.splice(index, 1);
			}
		}
		this.checkedCheckboxes = this.arr.join(',');
	},

	checkIfChecked: function() {
		if (this.arr.length > 0) {
			this.modalSubmit.classList.remove('jsDisabled');
		} else {
			this.modalSubmit.classList.add('jsDisabled');
		}
	},

	clearCheckboxCache: function() {
		this.arr = [];
		[].slice.call(this.allCheckboxes).forEach(checkbox => {
			if (checkbox.hasAttribute("checked")) {
				checkbox.checked = true;
				this.getCheckboxesValue(checkbox);
			} else {
				checkbox.checked = false;
			}
		});
		this.checkIfChecked();
	}
}
